import { colors } from '../styleguide';

export const PILLAR_COLORS = [
  colors.green100,
  colors.purple100,
  colors.orange100,
  colors.yellow100,
  colors.red100,
];
